<div class="row tabs-cont hide-nav-link" #tabsCont>
  <div class="col-md-12 h-100">
    <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false">
      <ngb-tab title="Pregled" id="tbList"
               [disabled]="tabsContainerService.IsListTabDisabled">
        <ng-template ngbTabContent>
          <!-- <div class="btn-group mr-2" style="margin-left: 10px;">
            <button class="btn btn-outline-primary" type="button" (click)="UpdateKomitentPoPib()" container="body"
                ngbTooltip="{{'KOMITENT.AZURIRAJKOMITENTENBS.TOOLTIP' | translate }}" placement="bottom"
                [disabled]=" defaulList.mainItems ? defaulList.mainItems.count()==0 : true">
                <i class="fas fa-file-alt"></i>
                <span style="padding-left: 5px;" translate="KOMITENT.AZURIRAJKOMITENTNBS.SINGULAR"></span>
              </button>
            </div> -->
          <ng-template #extraButtons>
            <div class="btn-group mr-2" style="margin-left: 10px;">
              <button class="btn btn-outline-primary" type="button" (click)="UpdateKomitentPoPib()" container="body"
                      ngbTooltip="{{'KOMITENT.AZURIRAJKOMITENTENBS.TOOLTIP' | translate }}" placement="bottom"
                      [disabled]=" defaulList.mainItems ? defaulList.mainItems.count()==0 : true">
                <i class="fas fa-file-alt"></i>
                <span style="padding-left: 5px;" translate="KOMITENT.AZURIRAJKOMITENTNBS.SINGULAR"></span>
              </button>
            </div>
          </ng-template>
          <yt-fw-default-list-tabs #defaulList [CondensedTable]="true" [extraButtonsTemplate]="extraButtons">
          </yt-fw-default-list-tabs>
        </ng-template>
      </ngb-tab>
      <ngb-tab title="Izmena" id="tbUpdate"
               [disabled]="tabsContainerService.IsUpdateTabDisabled">
        <ng-template ngbTabContent>
          <div class="row">
            <div class="col-md-12">
              <yt-komitent-tab-update #baseTabsUpdate></yt-komitent-tab-update>
            </div>
          </div>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
</div>
